export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">大家都在讨论的影视热点，跟上潮流不走丢</p>

        <div className="flex flex-wrap justify-center gap-3">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-200 transition-colors">
            <i className="ri-fire-line"></i> #暑期档必看
            <span className="text-xs text-primary-400">12.8w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-200 transition-colors">
            <i className="ri-fire-line"></i> #豆瓣9分神剧
            <span className="text-xs text-accent-400">9.6w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-secondary-200 transition-colors">
            <i className="ri-fire-line"></i> #国产悬疑天花板
            <span className="text-xs text-secondary-400">8.3w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-200 text-foreground-600 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-300 transition-colors">
            <i className="ri-fire-line"></i> #韩剧推荐
            <span className="text-xs text-foreground-400">7.5w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-200 transition-colors">
            <i className="ri-fire-line"></i> #漫威DC宇宙
            <span className="text-xs text-primary-400">6.9w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100/70 text-accent-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-200 transition-colors">
            <i className="ri-fire-line"></i> #日漫新番
            <span className="text-xs text-accent-400">6.2w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-100/70 text-secondary-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-secondary-200 transition-colors">
            <i className="ri-fire-line"></i> #纪录片精选
            <span className="text-xs text-secondary-400">5.7w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-200 text-foreground-600 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-300 transition-colors">
            <i className="ri-fire-line"></i> #综艺名场面
            <span className="text-xs text-foreground-400">5.1w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/50 text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-200 transition-colors">
            <i className="ri-fire-line"></i> #经典港片重温
            <span className="text-xs text-primary-400">4.4w</span>
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100/50 text-accent-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-200 transition-colors">
            <i className="ri-fire-line"></i> #动画电影
            <span className="text-xs text-accent-400">3.8w</span>
          </span>
        </div>
      </div>
    </section>
  );
}